
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    stretch: Boolean,
    inverse: Boolean,
    inline: {
      type: Boolean,
      default: false,
    },
  },
});
